module.exports = __webpack_public_path__ + "static/img/z_proposal4.5b1de1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ce/z_proposal4.png
// module id = efNZ
// module chunks = 171